import { request } from '@common/request';

const PATH = `${process.env.REACT_APP_API_URL_AUTHZ}/authz-service/api`;

/**
 * Api POST request for login with national ID + password (starts SMS OTP)
 */
export const loginByIdentityApi = async (
  identity_number: string,
  password: string
): Promise<any> => {
  const { data } = await request.post<any>({
    url: `${PATH}/auth/login-by-identity`,
    data: {
      identity_number,
      password,
    },
  });
  return data;
};

/**
 * Resend temporary password SMS (forgot-password)
 */
export const resendOtpCodeApi = async (
  identity_number: string
): Promise<any> => {
  const { data } = await request.post<any>({
    url: `${PATH}/auth/resend-code`,
    data: {
      identity_number,
    },
  });
  return data;
};

/**
 * Confirm SMS OTP after login-by-identity
 */
export const confirmOtpCodeAfterLoginApi = async (
  session: string,
  username: string,
  code: string
): Promise<any> => {
  const { data } = await request.post<any>({
    url: `${PATH}/auth/verify-OTP-after-login`,
    data: {
      session,
      username,
      code,
    },
  });
  return data;
};
